import React, { Component } from 'react';
import Ad from '../ad';
import AdDataService from '../../../services/ads/data';
import NoPartner from '../no-partner';
import CodeFund from '../codefund/codefund';
import SiteSubscription from '../../common/site-subscription';

export default class SmartAd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true
    };

    const { 
      isOnlySubscriptionPossible:isAdExistCheck,
      limitNumOfAdsPerSamePage,
      forceShowAd,
    } = this.props;

    AdDataService.getAdConf(props, isAdExistCheck, limitNumOfAdsPerSamePage, forceShowAd).then((conf) => {
      this.setState({
        conf,
        isLoading: false,
      });
    });
  }

  render() {
    const { conf, isLoading, } = this.state;
    const { subscriptionInfo, isOnlySubscriptionPossible, /*isMixAdSubscription*/ } = this.props;
    const isMixAdSubscription = false;
    const subscription = subscriptionInfo && <SiteSubscription { ...subscriptionInfo} />;

    if (isLoading) return <div />;

    if (!conf) {
      if (isMixAdSubscription && !isOnlySubscriptionPossible && subscription) return subscription;
      return <NoPartner />;
    }
    
    if (conf.codefund) {
      if (isMixAdSubscription && isOnlySubscriptionPossible && subscription) return subscription;

      return <CodeFund
        template='default'
        theme='light'
      />
    }
    
    if (conf.empty) {
      if (isMixAdSubscription && !isOnlySubscriptionPossible && subscription) return subscription;
      return <div />;
    }
    
    if (isMixAdSubscription && isOnlySubscriptionPossible && subscription) return subscription;
    return <Ad {...conf} />
  }
}

SmartAd.defaultValues = {
  isMixAdSubscription: false,
  isOnlySubscriptionPossible: false,  
}